export default {
  arquivo_relatorio_nao_encontrado:
    'Arquivo de configuração do relatório não encontrado',
  erro_ao_buscar_datasource: 'Erro ao buscar datasource',
};
